import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { Table, Modal, Button } from 'react-bootstrap';
import Sidebar from '../Components/Siderbar';
import Footer from '../Components/Footer';
import { toast } from 'react-toastify';
import { Dropdown } from 'react-bootstrap';
import { FaFileExport, FaSearch, FaEye, FaChevronLeft, FaChevronRight, FaClipboardList } from 'react-icons/fa';
import axios from 'axios';
import '../Customize_Css/ViewOrders.css';
import * as XLSX from 'xlsx';

const customerInitials = (name) => {
  const parts = String(name || '').trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return 'C';
  return parts.slice(0, 2).map((part) => part[0].toUpperCase()).join('');
};

const paymentTone = (payment) => {
  const value = String(payment || '').toLowerCase();
  if (value.includes('fail') || value.includes('cancel')) return 'is-bad';
  if (value.includes('pend') || value.includes('unpaid')) return 'is-wait';
  if (value.includes('paid') || value.includes('success')) return 'is-ok';
  return 'is-neutral';
};

const ViewOrders = () => {
  const location = useLocation();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const AuthorizationToken = localStorage.getItem('token');
  const userRole = localStorage.getItem('role');
  const epicxTenantId = localStorage.getItem('epicxTenantId');
  const employeeId = localStorage.getItem('employeeId');
  const [orders, setOrders] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showEmployeeModal, setShowEmployeeModal] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(location.state?.statusFilter || "order-placed");
  const [employees, setEmployees] = useState([]);
  const [currentOrder, setCurrentOrder] = useState(null);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [deliveryVendors, setDeliveryVendors] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [showVendorModal, setShowVendorModal] = useState(false);
  const [deliveryAgents, setDeliveryAgents] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 9;
  const [searchTerm, setSearchTerm] = useState('');

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [confirmAction, setConfirmAction] = useState(null);
  const [confirmMessage, setConfirmMessage] = useState('');
  const [confirmType, setConfirmType] = useState("normal");


const handleConfirm = (message, action, type = 'success') => {
  setConfirmMessage(message);
  setConfirmAction(() => action); 
  setConfirmType(type); 
  setShowConfirmModal(true);
};

// Status update
const handleStatusUpdateClick = (userId, orderId, nextStatus) => {
  handleConfirm(
    `Are you sure you want to change the status to "${formatStatus(nextStatus)}"?`,
    () => handleStatusUpdate(userId, orderId, nextStatus),
    'success' 
  );
};

// Cancel order
const handleCancelOrderClick = (userId, orderId) => {
  handleConfirm(
    'Are you sure you want to cancel this order?',
    () => handleCancelOrder(userId, orderId),
    'danger' 
  );
};



  const formatDate = (dateString) => {
    const options = { day: '2-digit', month: 'long', year: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-GB', options).replace(/ /g, '-');
  };

  const formatTime = (dateString) => {
    const options = { hour: '2-digit', minute: '2-digit', hour12: true};
    return new Date(dateString).toLocaleTimeString('en-GB', options);
  };

  useEffect(() => {
    const fetchFilteredOrders = async () => {
      if (selectedStatus) {
        try {
          const response = await fetch(`${BASE_URL}/orders/api/orders/${epicxTenantId}/orderStatus?orderStatus=${selectedStatus}`, {
            headers: {
              Authorization: `Bearer ${AuthorizationToken}`,
            },
          });
          if (!response.ok) throw new Error(`Network response was not ok: ${response.status}`);
          const data = await response.json();
          setOrders(data);
          setData(data);
        } catch (error) {
          console.error('Error fetching orders:', error);
          setOrders([]);
          toast.error('Error fetching orders');
        }
      } else {
        setOrders([]);
      }
    };
    fetchFilteredOrders();
  }, [selectedStatus, BASE_URL, AuthorizationToken]);

  const handleViewMore = (order) => {
    setSelectedProduct({
      orderId: order.orderId,
      userId: order.userId,
      address: order.address,
      deliverySlot: order.deliverySlot,
      deliveryTime: order.deliveryTime,
      orderStatus: order.orderStatus,
      products: order.products,
      statusHistory: order.statusHistory || [],
      assignedAgentFullName: order.assignedAgent?.fullName || 'Assigning your delivery partner soon!',
    });
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedProduct(null);
  };

  const formatStatus = (status) => {
    if (!status) return 'Status not available';
    return status
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const fetchEmployees = async () => {
    try {
      const response = await fetch(`${BASE_URL}/login/api/login/employees`, {
        headers: {
          Authorization: `Bearer ${AuthorizationToken}`,
        },
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(`Failed to fetch employees: ${errorData.message || response.status}`);
      }
      const data = await response.json();
      setEmployees(data);
      setShowEmployeeModal(true);
    } catch (error) {
      console.error('Error fetching employees:', error.message);
      toast.error(`Error fetching employees: ${error.message}`);
    }
  };

  const handleEmployeeSelection = (employeeId) => {
    setSelectedEmployee(employeeId);
  };
const handleStatusUpdate = async (userId, orderId, nextStatus) => {
  const userRole = localStorage.getItem('role');
  const employeeId = localStorage.getItem('employeeId') || '';
  const epicxTenantId = localStorage.getItem('epicxTenantId');

  const requestBody = {
    orderStatus: nextStatus,
    role: userRole,
    employeeId: userRole === 'employee' ? employeeId : '',
    tenantId: userRole === 'tenant' ? epicxTenantId : '',
  };

  try {
    const response = await fetch(`${BASE_URL}/orders/api/orders/${epicxTenantId}/${orderId}/updateStatus`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${AuthorizationToken}`,
      },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to update order status');
    }

    toast.success(`Order status updated to ${formatStatus(nextStatus)}! Check next tab.`);
    
    // Remove from current list
    setOrders(prev => prev.filter(o => o._id !== orderId));
    setData(prev => prev.filter(o => o._id !== orderId));
  } catch (error) {
    toast.error(error.message || 'Error updating order status');
  }
};

const handleEmployeeSubmit = async () => {
  if (!currentOrder || !selectedEmployee) {
    toast.error('Please select an employee');
    return;
  }

  const nextStatus = getStatusButtonLabel(currentOrder.orderStatus);

  const requestBody = {
    orderStatus: nextStatus,
    role: 'employee',
    employeeId: selectedEmployee,
    tenantId: '', 
  };

  try {
    const response = await fetch(
      `${BASE_URL}/orders/api/orders/${epicxTenantId}/${currentOrder._id}/updateStatus`,
      {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${AuthorizationToken}`,
        },
        body: JSON.stringify(requestBody),
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to update order status');
    }

    toast.success(`Order status updated to ${formatStatus(nextStatus)}! Check the "${formatStatus(nextStatus)}" tab.`);

    // Close modal and reset selection
    setShowEmployeeModal(false);
    setSelectedEmployee(null);
    setCurrentOrder(null); // Optional: clear currentOrder

    // Remove the updated order from the current list (it moved to next status tab)
    setOrders(prev => prev.filter(order => order._id !== currentOrder._id));
    setData(prev => prev.filter(order => order._id !== currentOrder._id));

  } catch (error) {
    console.error('Error updating order status:', error);
    toast.error(error.message || 'Error updating order status');
  }
};
const handleCancelOrder = async (userId, orderId) => {
  const epicxTenantId = localStorage.getItem('epicxTenantId');
  const userRole = localStorage.getItem('role');
  const employeeId = localStorage.getItem('employeeId') || '';

  if (!epicxTenantId) {
    toast.error('Tenant ID is missing');
    return;
  }

  if (userRole === 'employee' && !employeeId) {
    toast.error('Employee ID is missing. Please log in again.');
    return;
  }

  const requestBody = {
    orderStatus: 'order-cancelled',
    role: userRole,
    employeeId: userRole === 'employee' ? employeeId : '',
    tenantId: userRole === 'tenant' ? epicxTenantId : '',
  };

  try {
    const response = await fetch(
      `${BASE_URL}/orders/api/orders/${epicxTenantId}/${orderId}/updateStatus`,  
      {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${AuthorizationToken}`,
        },
        body: JSON.stringify(requestBody),
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to cancel order');
    }

    toast.success('Order cancelled successfully! Check the "Order Cancelled" tab.');

    // Remove the cancelled order from current view immediately (better UX)
    setOrders(prev => prev.filter(order => order._id !== orderId));
    setData(prev => prev.filter(order => order._id !== orderId));

  } catch (error) {
    console.error('Error cancelling order:', error);
    toast.error(error.message || 'Error cancelling order');
  }
};

  useEffect(() => {
    const fetchDeliveryVendors = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/deliveryVendor/api/deliveryVendor/${epicxTenantId}`, {
          headers: {
            Authorization: `Bearer ${AuthorizationToken}`,
          },
        });
        const deliveryVendorsList = response.data || [];
        const deliveryVendors = deliveryVendorsList.map(vendor => ({
          _id: vendor._id?.$oid || vendor._id,
          fullName: vendor.fullName,
          emailAddress: vendor.emailAddress,
          primaryMobileNumber: vendor.primaryMobileNumber,
          whatsappNumber: vendor.whatsappNumber,
        }));
        setDeliveryVendors(deliveryVendors);
      } catch (error) {
        console.error("Error fetching delivery vendors:", error);
        toast.error('Error fetching delivery vendors');
      }
    };
    fetchDeliveryVendors();
  }, [epicxTenantId, BASE_URL, AuthorizationToken]);

  const handleVendorSelection = async (vendorId) => {
    setSelectedVendor(vendorId);
    setDeliveryAgents([]);
    try {
      const response = await fetch(`${BASE_URL}/deliveryVendor/api/deliveryVendorAgents/deliveryVendor-agents/${vendorId}`, {
        headers: {
          Authorization: `Bearer ${AuthorizationToken}`,
        },
      });
      if (!response.ok) throw new Error("Failed to fetch delivery agents");
      const data = await response.json();
      setDeliveryAgents(data);
    } catch (error) {
      console.error("Error fetching delivery agents:", error);
      toast.error('Error fetching delivery agents');
    }
  };

  // const handleNextClick = () => {
  //   setShowEmployeeModal(false);
  //   setShowVendorModal(true);
  // };

  const handleAgentSelection = (agentId) => {
    setSelectedAgent(agentId);
  };

  const statusOptions = [
    { value: "order-placed", label: "Order Placed" },
    { value: "order-confirmed", label: "Order Confirmed" },
    { value: "waiting-for-delivery-person", label: "Waiting for Delivery Person" },
    { value: "delivery-person-accepted", label: "Delivery Person Accepted" },
    { value: "on-the-way-to-pickup", label: "On the way to pickup" },
    { value: "order-getting-prepared", label: "Order Getting Prepared" },
    { value: "arrived-at-location", label: "Arrived at Location" },
    { value: "package-picked", label: "Package Picked" },
    { value: "on-the-way-to-delivery", label: "On the way to delivery" },
    { value: "order-delivered", label: "Order Delivered" },
    { value: "order-cancelled", label: "Order Cancelled" },
  ];

  const tabContainerRef = useRef(null);

  useEffect(() => {
    const container = tabContainerRef.current;
    if (!container) return;
    const activeTab = container.querySelector('[aria-selected="true"]');
    if (activeTab) {
      activeTab.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
    }
  }, [selectedStatus]);

  const handleTabClick = (status) => {
    setSelectedStatus(status);
    setSearchTerm('');
    setCurrentPage(1);
    setSelectedItems([]);
  };

  useEffect(() => {
    const pages = Math.max(1, Math.ceil(orders.length / itemsPerPage));
    if (currentPage > pages) {
      setCurrentPage(pages);
    }
  }, [orders.length, currentPage]);

  const scrollTabs = (direction) => {
    const container = tabContainerRef.current;
    if (direction === "left") {
      container.scrollBy({ left: -200, behavior: "smooth" });
    } else {
      container.scrollBy({ left: 200, behavior: "smooth" });
    }
  };

  const getStatusButtonLabel = (status) => {
    switch (status) {
      case 'order-placed': return 'order-confirmed';
      // case 'order-confirmed': return 'waiting-for-delivery-person';
      case 'order-confirmed': return 'on-the-way-to-pickup';
      case 'on-the-way-to-pickup': return 'order-getting-prepared';
      case 'order-getting-prepared': return 'arrived-at-location';
      case 'arrived-at-location': return 'package-picked';
      case 'package-picked': return 'on-the-way-to-delivery';
      case 'on-the-way-to-delivery': return 'order-delivered';
      default: return 'No status found';
    }
  };

  const handleSelectAll = () => {
    if (selectedItems.length === data.length) {
      setSelectedItems([]);
    } else {
      setSelectedItems(data.map(item => item._id));
    }
  };

  const handleSelectItem = (_id) => {
    setSelectedItems(prev => prev.includes(_id) ? prev.filter(item => item !== _id) : [...prev, _id]);
  };

  const totalPages = Math.ceil(orders.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = orders.slice(indexOfFirstItem, indexOfLastItem);
  const rangeStart = orders.length === 0 ? 0 : indexOfFirstItem + 1;
  const rangeEnd = Math.min(indexOfLastItem, orders.length);
  const activeStatusLabel = formatStatus(selectedStatus);
  const handleSearch = (value) => {
    setSearchTerm(value);
    if (!value) {
      setOrders(data); 
      setCurrentPage(1);
      return;
    }

    const filtered = data.filter(order =>
      order.orderId?.toLowerCase().includes(value.toLowerCase()) ||
      order.userId?.toLowerCase().includes(value.toLowerCase()) ||
      order.address?.name?.toLowerCase().includes(value.toLowerCase()) ||
      order.products.some(p => p.productName?.toLowerCase().includes(value.toLowerCase()))
    );

    setOrders(filtered);
    setCurrentPage(1);
  };
  const handleExport = () => {
    const exportData = orders.flatMap(order =>
      order.products.map(product => ({
        "Order ID": order.orderId,
        "Customer Name": order.address?.name || 'N/A',
        "Customer ID": order.userId,
        "Phone No": order.address?.phoneNo || 'N/A',
        "Product Name": product.productName,
        "Vendor Name": order.productVendorName || 'N/A',
        "Weight (kg)": product.productWeight || 'N/A',
        "Quantity": product.productQuantity,
        "Price/Item": product.perItemPrice,
        "Order Date": formatDate(order.orderDate),
        "Order Time": formatTime(order.orderDate),
        "Delivery Date": order.deliverySlot,
        "Total Amount": order.totalProductPrice,
        "Payment Status": order.payment,
      }))
    );

    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Orders");
    XLSX.writeFile(wb, 'orders_data.xlsx');
  };

  return (
    <>
      <Sidebar />
      <div className="orders-page">
        <header className="orders-hero">
          <div>
            <p className="orders-kicker">Sales</p>
            <h1>Orders</h1>
            <p>Follow each order from placement to delivery. Search, update the stage, or open the full details.</p>
          </div>
          <div className="orders-hero-stat">
            <span>{orders.length}</span>
            <small>{activeStatusLabel}</small>
          </div>
        </header>

        <div className="orders-status-bar">
          <button type="button" className="orders-scroll" onClick={() => scrollTabs('left')} aria-label="Show earlier statuses">
            <FaChevronLeft aria-hidden="true" />
          </button>
          <div className="orders-tabs" ref={tabContainerRef} role="tablist" aria-label="Order status">
            {statusOptions.map(option => (
              <button
                key={option.value}
                type="button"
                role="tab"
                aria-selected={selectedStatus === option.value}
                className={`orders-tab tone-${option.value} ${selectedStatus === option.value ? 'is-active' : ''}`}
                onClick={() => handleTabClick(option.value)}
              >
                {option.label}
              </button>
            ))}
          </div>
          <button type="button" className="orders-scroll" onClick={() => scrollTabs('right')} aria-label="Show later statuses">
            <FaChevronRight aria-hidden="true" />
          </button>
        </div>

        <section className="orders-toolbar" aria-label="Order search and export">
          <p className="orders-toolbar-note">
            {selectedItems.length > 0
              ? <><strong>{selectedItems.length}</strong> selected</>
              : <>Showing <strong>{activeStatusLabel}</strong>. Search by order, customer, or product.</>}
          </p>
          <div className="orders-toolbar-actions">
            <div className="orders-search">
              <FaSearch aria-hidden="true" />
              <input
                type="text"
                className="form-control"
                placeholder="Search orders..."
                aria-label="Search orders"
                value={searchTerm}
                onChange={(e) => handleSearch(e.target.value)}
              />
            </div>
            <Dropdown>
              <Dropdown.Toggle className="orders-action-btn">Action</Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={handleExport}>
                  <FaFileExport className="me-2" /> Export
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </section>

        <section className="orders-card">
          <div className="orders-card-head">
            <div>
              <h2>{activeStatusLabel}</h2>
              <p>
                {searchTerm
                  ? `Results for “${searchTerm}”`
                  : 'One row per product. Updating a status applies to the whole order.'}
              </p>
            </div>
            <span className="orders-count">
              <FaClipboardList aria-hidden="true" />
              {orders.length} {orders.length === 1 ? 'order' : 'orders'}
            </span>
          </div>
          {currentData.length > 0 ? (
            <div className="orders-table-wrap">
              <table className="orders-table">
                <thead>
                  <tr>
                    <th className="orders-check">
                      <input
                        type="checkbox"
                        aria-label="Select all orders"
                        checked={selectedItems.length === currentData.length && currentData.length > 0}
                        onChange={handleSelectAll}
                      />
                    </th>
                    <th>S.No</th>
                    <th>Order Id</th>
                    <th>Customer</th>
                    <th>Product</th>
                    <th>Vendor</th>
                    <th>Ordered</th>
                    <th>Delivery</th>
                    <th>Total</th>
                    <th>Payment</th>
                    <th className="orders-sticky">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {currentData.map((order, orderIndex) =>
                    order.products.map((product, productIndex) => {
                      const statusLocked = order.orderStatus === 'order-delivered' || order.orderStatus === 'order-cancelled';
                      const nextStatus = getStatusButtonLabel(order.orderStatus);
                      const customerName = order.address ? order.address.name : 'N/A';
                      return (
                        <tr
                          key={product._id || `${orderIndex}-${productIndex}`}
                          className={selectedItems.includes(product._id) ? 'is-selected' : ''}
                        >
                          <td className="orders-check">
                            <input
                              type="checkbox"
                              aria-label={`Select ${product.productName || 'product'}`}
                              checked={selectedItems.includes(product._id)}
                              onChange={() => handleSelectItem(product._id)}
                            />
                          </td>
                          <td>{(orderIndex * order.products.length + productIndex + 1)}</td>
                          <td><span className="orders-id" title={order.orderId}>{order.orderId}</span></td>
                          <td>
                            <div className="orders-person">
                              <span className="orders-avatar" aria-hidden="true">{customerInitials(customerName)}</span>
                              <div className="orders-stack">
                                <strong title={customerName}>{customerName}</strong>
                                <a href="#" className="orders-customer-link" onClick={(event) => event.preventDefault()}>{order.userId}</a>
                                <small>{order.address ? order.address.phoneNo : 'N/A'}</small>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div className="orders-product">
                              {product.productImages ? (
                                <img
                                  src={product.productImages}
                                  alt=""
                                  className="orders-thumb"
                                  onError={(event) => { event.currentTarget.style.display = 'none'; }}
                                />
                              ) : (
                                <span className="orders-thumb-fallback" aria-hidden="true">
                                  {(product.productName || 'P').charAt(0).toUpperCase()}
                                </span>
                              )}
                              <div className="orders-stack">
                                <span className="orders-product-name" title={product.productName}>{product.productName}</span>
                                <small>
                                  {product.productWeight ? `${product.productWeight} kg` : 'N/A'} · Qty {product.productQuantity} · ₹{product.perItemPrice}
                                </small>
                              </div>
                            </div>
                          </td>
                          <td><span className="orders-clip" title={order.productVendorName || 'N/A'}>{order.productVendorName || 'N/A'}</span></td>
                          <td>
                            <div className="orders-stack">
                              <span>{formatDate(order.orderDate)}</span>
                              <small>{formatTime(order.orderDate)}</small>
                            </div>
                          </td>
                          <td>{order.deliverySlot}</td>
                          <td><span className="orders-money">₹{order.totalProductPrice}</span></td>
                          <td>
                            <span className={`orders-pay ${paymentTone(order.payment)}`}>{order.payment || 'N/A'}</span>
                          </td>
                          <td className="orders-sticky">
                            <div className="orders-actions">
                              <button
                                type="button"
                                className="orders-advance"
                                title={statusLocked ? formatStatus(order.orderStatus) : formatStatus(nextStatus)}
                                onClick={() => handleStatusUpdateClick(order.userId, order._id, nextStatus)}
                                disabled={statusLocked}
                              >
                                {statusLocked ? formatStatus(order.orderStatus) : formatStatus(nextStatus)}
                              </button>
                              <div className="orders-action-row">
                                {order.orderStatus === 'order-placed' && (
                                  <button
                                    type="button"
                                    className="orders-cancel"
                                    onClick={() => handleCancelOrderClick(order.userId, order._id)}
                                  >
                                    Cancel
                                  </button>
                                )}
                                <button
                                  type="button"
                                  className="orders-view"
                                  onClick={() => handleViewMore(order)}
                                >
                                  <FaEye aria-hidden="true" /> View More
                                </button>
                              </div>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="orders-empty">
              <span><FaClipboardList aria-hidden="true" /></span>
              <h3>No orders found</h3>
              <p>
                {searchTerm
                  ? 'Try a different order id, customer, or product name.'
                  : `No orders are in ${activeStatusLabel} right now.`}
              </p>
            </div>
          )}
          <div className="orders-card-footer">
            <span className="orders-page-summary">
              {orders.length > 0
                ? `Showing ${rangeStart}–${rangeEnd} of ${orders.length} orders`
                : 'Total Orders: 0'}
            </span>
            <div className="orders-pagination">
              <nav>
                <ul className="pagination mb-0" aria-label="Orders pagination">
                  <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(1)} aria-label="First page">«</button>
                  </li>
                  <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} aria-label="Previous page">{'<'}</button>
                  </li>
                  <li className="page-item active">
                    <button className="page-link" aria-current="page">{currentPage}</button>
                  </li>
                  <li className={`page-item ${currentPage === totalPages || totalPages === 0 ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} aria-label="Next page">{'>'}</button>
                  </li>
                  <li className={`page-item ${currentPage === totalPages || totalPages === 0 ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(totalPages)} aria-label="Last page">»</button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </section>

        <div className="orders-footer">
          <Footer />
        </div>
      </div>

      <Modal show={showModal} onHide={handleCloseModal} size="lg" dialogClassName="orders-details-modal" centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <span className="orders-title-icon"><FaClipboardList aria-hidden="true" /></span>
            <span>
              <small>Order</small>
              {selectedProduct?.orderId || 'N/A'}
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedProduct && (
            <>
              <div className="orders-summary">
                <div>
                  <h3>{selectedProduct.address?.name || selectedProduct.name || 'Customer'}</h3>
                  <p>{selectedProduct.userId}</p>
                </div>
                <span className="orders-status-badge">{formatStatus(selectedProduct.orderStatus || 'order-placed')}</span>
              </div>
              <div className="orders-detail-grid">
                <div>
                  <span>User ID</span>
                  <strong>{selectedProduct.userId}</strong>
                </div>
                <div>
                  <span>Delivery Slot</span>
                  <strong>{selectedProduct.deliverySlot}</strong>
                </div>
                <div className="is-wide">
                  <span>Delivery Time</span>
                  {selectedProduct.deliveryTime ? (
                    <strong>{selectedProduct.deliveryTime}</strong>
                  ) : (
                    <p className="orders-callout">
                      Your {selectedProduct.products.map(product => product.productName).join(', ')} order is Non-Calenderized, so a delivery time is yet to be scheduled!
                    </p>
                  )}
                </div>
              </div>

              <div className="orders-block">
                <h4>Products</h4>
                <div className="orders-product-list">
                  {selectedProduct.products.map((product) => (
                    <div className="orders-product-card" key={product._id.$oid || product._id}>
                      {product.productImages && (
                        <img src={product.productImages} alt={product.productName} />
                      )}
                      <div>
                        <h5>{product.productName}</h5>
                        <div className="orders-product-meta">
                          <p><strong>Weight:</strong> {product.productWeight ? `${product.productWeight} kg` : 'N/A'}</p>
                          <p><strong>Quantity:</strong> {product.productQuantity}</p>
                          <p><strong>Price/Item:</strong> ₹{product.perItemPrice}</p>
                          <p><strong>SKU:</strong> {product.childSKU}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {selectedProduct.address && (
                <div className="orders-address">
                  <h4>Delivery Address</h4>
                  <div className="orders-address-grid">
                    <p><strong>Name:</strong> {selectedProduct.address.name || selectedProduct.name || 'N/A'}</p>
                    <p><strong>Phone:</strong> {selectedProduct.address.phoneNo}</p>
                    <p><strong>House No:</strong> {selectedProduct.address.houseNo}</p>
                    <p><strong>Apartment:</strong> {selectedProduct.address.apartment}</p>
                    <p><strong>Address:</strong> {selectedProduct.address.address}</p>
                    <p><strong>Saved As:</strong> {selectedProduct.address.saveAs}</p>
                  </div>
                </div>
              )}

              <div className="orders-partner">
                <h4>Delivery Partner</h4>
                {selectedProduct.assignedAgentFullName || selectedProduct.delivertAgentName ? (
                  <p><strong>Agent Name:</strong> {selectedProduct.assignedAgentFullName || selectedProduct.delivertAgentName || 'Not yet assigned'}</p>
                ) : (
                  <p>Not yet assigned</p>
                )}
              </div>

              {selectedProduct.statusHistory && selectedProduct.statusHistory.length > 0 && (
                <div className="orders-history">
                  <h4>Status History</h4>
                  <Table bordered hover className="orders-history-table">
                    <thead>
                      <tr>
                        <th>Status</th>
                        <th>Changed By</th>
                        <th>Changed At</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedProduct.statusHistory.map((history, index) => (
                        <tr key={index}>
                          <td>{formatStatus(history.orderStatus)}</td>
                          <td>
                            {history.changedBy?.role === 'tenant' ? 'Admin' :
                             history.changedBy?.role === 'employee' ? `Employee (${history.changedBy.id})` :
                             'System'}
                          </td>
                          <td>{formatDate(history.changedAt)} {formatTime(history.changedAt)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              )}
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button className="orders-modal-close" onClick={handleCloseModal}>Close</Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showEmployeeModal} onHide={() => setShowEmployeeModal(false)} size="lg" dialogClassName="orders-picker-modal" centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <span className="orders-title-icon"><FaClipboardList aria-hidden="true" /></span>
            <span>
              <small>Assignment</small>
              Select Employee
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table bordered hover className="orders-history-table">
            <thead><tr><th>Select</th><th>Employee ID</th><th>Employee Name</th><th>Phone Number</th><th>Email</th></tr></thead>
            <tbody>
              {employees.map(employee => (
                <tr key={employee._id}>
                  <td><input type="radio" name="employee" onChange={() => handleEmployeeSelection(employee._id)} checked={selectedEmployee === employee._id} /></td>
                  <td>{employee.employeeId}</td>
                  <td>{employee.employeeName}</td>
                  <td>{employee.phoneNumber}</td>
                  <td>{employee.emailId}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button className="orders-modal-close" onClick={() => setShowEmployeeModal(false)}>Cancel</Button>
          <Button className="orders-modal-primary" onClick={handleEmployeeSubmit} disabled={!selectedEmployee}>Submit as Employee</Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showVendorModal} onHide={() => setShowVendorModal(false)} size="lg" dialogClassName="orders-picker-modal" centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <span className="orders-title-icon"><FaClipboardList aria-hidden="true" /></span>
            <span>
              <small>Delivery</small>
              Select Delivery Vendor and Agent
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <h5>Select Vendor</h5>
            <Table bordered hover className="orders-history-table">
              <thead><tr><th>Select</th><th>Vendor Name</th><th>Email</th><th>Phone</th></tr></thead>
              <tbody>
                {deliveryVendors.map(vendor => (
                  <tr key={vendor._id}>
                    <td><input type="radio" name="vendor" onChange={() => handleVendorSelection(vendor._id)} checked={selectedVendor === vendor._id} /></td>
                    <td>{vendor.fullName}</td>
                    <td>{vendor.emailAddress}</td>
                    <td>{vendor.primaryMobileNumber}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          {deliveryAgents.length > 0 && (
            <div>
              <h5>Select Delivery Agent</h5>
              <Table bordered hover className="orders-history-table">
                <thead><tr><th>Select</th><th>Agent Name</th><th>Email</th><th>Phone</th></tr></thead>
                <tbody>
                  {deliveryAgents.map(agent => (
                    <tr key={agent._id}>
                      <td><input type="radio" name="agent" onChange={() => handleAgentSelection(agent._id)} checked={selectedAgent === agent._id} /></td>
                      <td>{agent.fullName}</td>
                      <td>{agent.emailAddress}</td>
                      <td>{agent.primaryMobileNumber}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button className="orders-modal-close" onClick={() => setShowVendorModal(false)}>Cancel</Button>
          <Button className="orders-modal-primary" disabled={!selectedVendor || !selectedAgent}>Submit</Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showConfirmModal}
        onHide={() => setShowConfirmModal(false)}
        centered
        backdrop="static"
        keyboard={false}
        contentClassName={`orders-confirm-modal ${confirmType === 'danger' ? 'is-danger' : 'is-success'}`}
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Action</Modal.Title>
        </Modal.Header>
        <Modal.Body className="orders-confirm-body">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            fill={confirmType === 'danger' ? '#dc3545' : '#12956a'}
            viewBox="0 0 16 16"
            aria-hidden="true"
          >
            <path d="M8.982 1.566a1.13 1.13 0 0 0-1.964 0L.165 13.233c-.457.778.091 1.767.982 1.767h13.706c.89 0 1.438-.99.982-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
          </svg>
          <p>{confirmMessage}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button className="orders-confirm-cancel" variant="secondary" onClick={() => setShowConfirmModal(false)}>
            Cancel
          </Button>
          <Button
            className={`orders-confirm-ok ${confirmType === 'danger' ? 'is-danger' : 'is-success'}`}
            variant={confirmType}
            onClick={() => {
              if (confirmAction) confirmAction();
              setShowConfirmModal(false);
            }}
          >
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ViewOrders;
